/* 同步 */
import { storage } from '../utils/utils';

const UPDATE_ISCOLLAPSE = 'UPDATE_ISCOLLAPSE'
const SAVE_USERINFO = 'SAVE_USERINFO'
const EXIT_LOGIN = 'EXIT_LOGIN'
const SAVE_LOGININFO = 'SAVE_LOGININFO'
const ClEAR_LOGININFO = 'ClEAR_LOGININFO'
const SAVE_NAVS = 'SAVE_NAVS';
const SAVE_OPERATE = 'SAVE_OPERATE'
export default {
  [UPDATE_ISCOLLAPSE](state, isCollapse) {
    storage.set('isCollapse', isCollapse);
    state.isCollapse = isCollapse;
  },
  // 存储用户信息和TOKEN
  [SAVE_USERINFO](state, userInfo) {
    state.userInfo = userInfo;
    state.token = userInfo.token;
    storage.set('userInfo', userInfo);
    storage.set('token', userInfo.token);
  },
  // 退出登录
  [EXIT_LOGIN](state) {
    state.userInfo = null;
    state.token = '';
    localStorage.clear();
  },
  // 保存登录信息
  [SAVE_LOGININFO](state, loginInfo) {
    storage.set('loginInfo',loginInfo);
  },
  [SAVE_NAVS](state, navs) {
    storage.set('navs',navs);
  },
  [SAVE_OPERATE](state, operate) {
    storage.set('operate',operate);
  },
  // 清除登录信息
  [ClEAR_LOGININFO]() {
    storage.set('loginInfo',null);
  }
}